import {
  headerCellStyle,
  productNameStyle,
  productPresentationStyle,
  productPricingStyle,
} from '@/components/Order/OrderDetails/style';
import COLORS from '@/constants/colors';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useProductListViewController } from './ProductListViewController';

export function ProductList() {
  const { uiState } = useProductListViewController();

  return (
    <TableContainer
      sx={{
        background: 'white',
        border: `1px solid ${COLORS.gray_6}`,
        borderRadius: '8px',
      }}
    >
      <Table>
        <TableHead sx={{ borderBottom: `1.5px solid ${COLORS.gray_6}` }}>
          <TableRow>
            <TableCell sx={headerCellStyle}>Producto</TableCell>
            <TableCell sx={headerCellStyle}>Cantidad</TableCell>
            <TableCell sx={headerCellStyle}>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {uiState.products.map((product) => (
            <TableRow key={product.id}>
              <TableCell>
                <Stack direction={'row'} spacing={'16px'}>
                  {product?.image ? (
                    <img
                      style={{
                        width: '44px',
                        height: '44px',
                        alignSelf: 'center',
                      }}
                      src={product.image}
                      alt={product.name || 'prod'}
                    />
                  ) : (
                    <ImageNotSupportedOutlinedIcon
                      style={{ width: '16px', height: '16px' }}
                    />
                  )}
                  <Stack>
                    <Typography sx={productNameStyle}>
                      {product.name}
                    </Typography>
                    <Typography sx={productPresentationStyle}>
                      {product.presentation}
                    </Typography>
                    <Typography sx={productPricingStyle}>
                      {product.pricing}
                    </Typography>
                  </Stack>
                </Stack>
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  color: COLORS.gray_700,
                }}
              >
                {product.quantity}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  color: COLORS.gray_700,
                }}
              >
                ${product.totalAmount}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
